<template>
    <div>
        <strong>Oryginalne zdjęcie</strong>
        <div>
            <div class="file-upload-form">
                <image-input-component :value="photo" @input="onImageChange"/>
            </div>
        </div>
        <div class="cropper-wrapper" v-for="cropper in croppers" v-show="photo">
            <strong>{{ cropper.label }}</strong>

            <p v-if="errors && errors[cropper.paramsFieldName]" class="errors">
                {{ errors[cropper.paramsFieldName] }}
            </p>
            <img :id="cropper.id" :src="photo" alt="">
        </div>
    </div>
</template>
<script>
    import Cropper from 'cropperjs'

    export default {
        data () {
            return {
                cropperjsInstance: {}
            }
        },
        methods: {
            emitChanges () {
                this.$emit('update:croppers', this.croppers)
            },
            destroyCroppers () {
                this.croppers.forEach(cropper => {
                    if (this.cropperjsInstance[cropper.id]) {
                        this.cropperjsInstance[cropper.id].destroy()
                        delete this.cropperjsInstance[cropper.id]
                    }
                })
            },
            updateData () {
                this.croppers.forEach(cropper => {
                    cropper.params = this.cropperjsInstance[cropper.id].getData()
                })
                this.emitChanges()
            },
            initializeCroppers () {
                if (!this.photo) {
                    return
                }

                this.destroyCroppers()

                const convertInitToPromise = cropper => new Promise((resolve, reject) => {
                    this.cropperjsInstance[cropper.id] = this.initializeCropper(cropper, resolve)
                })

                const croppersDone = this.croppers.map(convertInitToPromise)

                Promise.all(croppersDone).then(this.updateData)
            },
            initializeCropper (cropper, resolve) {
                return new Cropper(document.getElementById(cropper.id), {
                    aspectRatio: cropper.aspect,
                    zoomable: false,
                    scalable: false,
                    checkCrossOrigin: false,
                    ready: e => {
                        if (cropper.params) {
                            e.target.cropper.setData(cropper.params)
                        }
                        e.target.addEventListener('cropend', this.updateData)
                        resolve()
                    }
                })
            },
            onImageChange (file) {
                this.$emit('update:photo', file)
                setTimeout(this.initializeCroppers, 0)
            }
        },
        props: ['croppers', 'photo', 'errors'],
        watch: {
            photo (value) {
                setTimeout(this.initializeCroppers, 0)
            }
        }
    }
</script>
<style lang="scss" scoped>
    img {
        max-width: 100%;
    }

    .preview {
        margin-top: 15px;
    }

    .cropper-wrapper {
        margin: 25px 0;
    }
    .errors {
        color: #f56c6c;
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// PhotoCropper.vue?8b6c38b8